export default __webpack_public_path__ + "static/media/detail_main_img_9.4a81b4a7.png";